import { createContext } from 'react';

interface TableSemanticContextValues {
    location?: string;
}

export const TableSemanticContext = createContext<TableSemanticContextValues>({});
